import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';
import type {
  CreateCreditPlanRequest,
  UpdateCreditPlanRequest,
} from '@/types/credit-plan.types';

/**
 * Credit plan API (management-only). Each call returns the backend ResultEntity
 * (`{ data, ... }`); callers read `.data`.
 */
class CreditPlanService {
  async list(search?: string) {
    const response = await apiClient.post(API_ENDPOINTS.CREDIT_PLAN.LIST, { search: search?.trim() || undefined });
    return response.data;
  }

  async getByKey(plan_key: string) {
    const response = await apiClient.post(API_ENDPOINTS.CREDIT_PLAN.GET, { plan_key });
    return response.data;
  }

  async create(payload: CreateCreditPlanRequest) {
    const response = await apiClient.post(API_ENDPOINTS.CREDIT_PLAN.CREATE, payload);
    return response.data;
  }

  async update(plan_key: string, payload: UpdateCreditPlanRequest) {
    const response = await apiClient.put(API_ENDPOINTS.CREDIT_PLAN.UPDATE(plan_key), payload);
    return response.data;
  }

  async remove(plan_key: string) {
    const response = await apiClient.delete(API_ENDPOINTS.CREDIT_PLAN.DELETE(plan_key));
    return response.data;
  }
}

export const creditPlanService = new CreditPlanService();
